import { useSnapshot } from "valtio"
import { AccountStore, accountStore } from "./account-store"

export function useAccount() {
  return useSnapshot(accountStore) as AccountStore
}
